import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { archiveCheckTypesFailed, archiveCheckTypesSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* archiveCheckTypes(action) {
  try {
    if (!action.payload) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/resources/check-types/archive/${action.payload}`;
    const response = yield makeRequest(url, {}, action, 'PUT', true);
    if (response.status === OK) {
      yield put(archiveCheckTypesSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(archiveCheckTypesFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(archiveCheckTypesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
